import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../../helpers/request';
import { getQueryKeys } from '../../../../queries/queryKeys';
import { useSelector } from 'react-redux';
import { message } from 'antd';

const changeRegistrationTypesHouses = async ({
  housesArray,
  registrationType,
}) => {
  const housesIdArray = housesArray.map((house) => house.houseId);

  const body = {
    houseIds: housesIdArray,
    registrationTypeId: registrationType.id,
  };

  const res = await request.put(
    `/HousingStock/registration_type_on_houses`,
    body,
    'Не удалось изменить тип регистрации',
    'Error',
    undefined,
    {}
  );
  return res;
};

const changeTemplatesRegistrationTypesHouses = async ({
  housesArray,
  HouseAccessTypeId,
}) => {
  const housesIdArray = housesArray.map((house) => house.houseId);
  const objPost = {
    houseId: housesIdArray,
    houseAccessTypeId: HouseAccessTypeId,
  };
  const res = await request.post(
    `/HousingStock/change_template_access_type_houses`,
    JSON.stringify(objPost),
    'Не удалось изменить установить выбранный шаблон',
    'Error',
    undefined,
    {}
  );
  return res;
};

const useChangeRegistrationTypesHouses = () => {
  const queryClient = useQueryClient();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const mutation = useMutation(changeRegistrationTypesHouses, {
    onSuccess: async (
      data,
      { HouseAccessTypeId, housesArray, registrationType }
    ) => {
      if (data !== 'Error') {
        if (HouseAccessTypeId || HouseAccessTypeId === 0) {
          await changeTemplatesRegistrationTypesHouses({
            housesArray,
            HouseAccessTypeId,
          });
        }
        message.success('Тип регистрации успешно изменен', 2);
        queryClient.setQueryData(
          getQueryKeys.housingStockHouses({ companyId: currentCompany?.id }),
          (oldData) =>
            oldData.map((oldHouse) => {
              const updateHouse = housesArray.find(
                (house) => house.houseId === oldHouse.houseId
              );
              return updateHouse ? { ...oldHouse, registrationType } : oldHouse;
            })
        );
      }
    },
  });

  return {
    changeAsync: mutation.mutateAsync,
    loading: mutation.isLoading,
  };
};

export { useChangeRegistrationTypesHouses };
